import { render, staticRenderFns } from "./salaryDetail.vue?vue&type=template&id=cca8ad5e&scoped=true&"
import script from "./salaryDetail.vue?vue&type=script&lang=js&"
export * from "./salaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./salaryDetail.vue?vue&type=style&index=0&id=cca8ad5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca8ad5e",
  null
  
)

export default component.exports